import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.285 12.828c-3.268 0-3.137 3.72-.393 3.72 1.833 0 3.226-1.031 4.002-2.716a7.24 7.24 0 0 0-3.61-1.004zm6.622 4.459c-1.57 2.015-3.913 3.233-6.883 3.233-9.495 0-9.278-11.704.696-11.704 1.334.008 2.656.247 3.902.705-.239-3.52-2.932-5.499-7.17-5.537L5.187 3.94l.038 21.69h9.627c4.179 0 6.488-1.715 6.488-6.018a6.3 6.3 0 0 0-.433-2.323zm2.075-4.988c1.935 1.947 3.016 4.534 3.018 7.225 0 6.602-4.182 10.062-11.148 10.062H.043L0 0h12.543C19.117 0 23.17 3.886 23.17 9.902c.001.802-.062 1.603-.188 2.395z"
    }, null, -1)
  ]))]))
}
export default { render: render }